export const SideBarType = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  PAGE_SEARCHER: 'PAGE_SEARCHER'
};

export const ToolBarDirection = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
};

export const ReaderToolType = {
  BackToCatalog: 'BackToCatalog',
  Menu: 'Menu',
  Bookshelf: 'Bookshelf',
  PageMode: 'PageMode',
  Drag: 'Drag',
  Painter: 'Painter',
  Select: 'Select',
  Painting: 'Painting',
  Highlighter: 'Highlighter',
  Shape: 'Shape',
  Line: 'Line',
  DeleteAll: 'DeleteAll',
  Delete: 'Delete',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  PageSearcher: 'PageSearcher',
  FourZoomIn: 'FourZoomIn',
  AllScreen: 'AllScreen',
  IntervalZoomIn: 'IntervalZoomIn',
  Whiteboard: 'Whiteboard',
  NumberPicker: 'NumberPicker',
  Img: 'Img',
  Text: 'Text',
  SVG: 'SVG',
  AttendeeNumber: 'AttendeeNumber',
  Bookmark: 'Bookmark',
  ReaderOption: 'ReaderOption',
  Activity: 'Activity',
  OpenActivity: 'OpenActivity',
  ExportInteractiveObject: 'ExportInteractiveObject',
  RightSideBar: 'RightSideBar',
  Mark: 'Mark',
  FullWidth: 'FullWidth',
  OfflineReaderToolBox: 'OfflineReaderToolBox',
  StickyNote: 'StickyNote',
  Expression: 'Expression',
  MathTools: 'MathTools',
  Toolbox: 'Toolbox',
  ResetLastAnnatation: 'ResetLastAnnatation'
};

export const ReaderZoomType = {
  LeftTop: "LeftTop",
  RightTop: "RightTop",
  LeftBottom: "LeftBottom",
  RightBottom: "RightBottom",
  OriginZoom: "OriginZoom",
  AreaZoom: "AreaZoom",
  WheelZoom: "WheelZoom",
  PanZoom: "PanZoom",
  RangeZoom: "RangeZoom",
};

export const DefaultLeftReaderTools = [
  ReaderToolType.BackToCatalog,
  ReaderToolType.Toolbox,
];


export const SVGCanvasSwitchType = {
  SVG: "SVG",
  CANVAS: "CANVAS"
};

export const DefaultReaderTools = [
  ReaderToolType.Expression,
  ReaderToolType.Drag,
  ReaderToolType.Painting,
  ReaderToolType.Highlighter,
  ReaderToolType.DeleteAll,
  ReaderToolType.Delete,
  ReaderToolType.ArrowLeft,
  ReaderToolType.PageSearcher,
  ReaderToolType.ArrowRight,
  ReaderToolType.FourZoomIn,
  ReaderToolType.AllScreen,
  ReaderToolType.IntervalZoomIn,
  ReaderToolType.NumberPicker,
  ReaderToolType.Select,
  ReaderToolType.StickyNote,
  ReaderToolType.Whiteboard,
  ReaderToolType.ReaderOption,
  ReaderToolType.SVG,
  ReaderToolType.Text,
  ReaderToolType.Img,
  ReaderToolType.ResetLastAnnatation,
];

export const DefaultTutorTeacherReaderTools = [
  ReaderToolType.Expression,
  ReaderToolType.Drag,
  ReaderToolType.Painting,
  ReaderToolType.Highlighter,
  ReaderToolType.DeleteAll,
  ReaderToolType.Delete,
  ReaderToolType.ArrowLeft,
  ReaderToolType.PageSearcher,
  ReaderToolType.ArrowRight,
  ReaderToolType.FourZoomIn,
  ReaderToolType.AllScreen,
  ReaderToolType.NumberPicker,
  ReaderToolType.Select,
  ReaderToolType.StickyNote,
  ReaderToolType.SVG,
  ReaderToolType.Text,
  ReaderToolType.Img,
  ReaderToolType.ResetLastAnnatation,
];

export const DefaultMiddleReaderTools = [
  ReaderToolType.Drag,
  ReaderToolType.Painting,
  ReaderToolType.Highlighter,
  ReaderToolType.Shape,
  ReaderToolType.DeleteAll,
  ReaderToolType.Delete,
  ReaderToolType.ArrowLeft,
  ReaderToolType.PageSearcher,
  ReaderToolType.ArrowRight,
  ReaderToolType.FourZoomIn,
  ReaderToolType.AllScreen,
  ReaderToolType.IntervalZoomIn,
  ReaderToolType.NumberPicker,
  ReaderToolType.Select,
  ReaderToolType.StickyNote,
  ReaderToolType.Text,
  ReaderToolType.Whiteboard,
  ReaderToolType.Img,
  ReaderToolType.Mark,
  ReaderToolType.Line,
  ReaderToolType.SVG,
  ReaderToolType.PageMode,
  ReaderToolType.StickyNote,
  ReaderToolType.MathTools,
  ReaderToolType.Menu,
  ReaderToolType.Bookshelf,
  ReaderToolType.ReaderOption,
  ReaderToolType.ResetLastAnnatation,
];

export const DefaultRightReaderTools = [
  ReaderToolType.OfflineReaderToolBox,
  ReaderToolType.AttendeeNumber,
  ReaderToolType.Bookmark,
  ReaderToolType.Activity,
  // OpenActivity,
  ReaderToolType.ExportInteractiveObject,
  // RightSideBar,
];

export const ToolboxCategory = {
  Settings:'Settings',
  Controls:'Controls',
  EditTools: 'EditTools',
  TeachingTools: 'TeachingTools',
  MathTools: 'MathTools',
  OfflineTools: 'OfflineTools'
};

export const DefaultToolboxCategory = [
  ToolboxCategory.Settings,
  ToolboxCategory.Controls,
  ToolboxCategory.EditTools,
  ToolboxCategory.TeachingTools,
  ToolboxCategory.MathTools
]

export const ReaderToolbox = {
  Settings: [
    ReaderToolType.ReaderOption,
    ReaderToolType.Bookshelf,
    ReaderToolType.SVG,
  ],
  Controls: [
    ReaderToolType.BackToCatalog,
    ReaderToolType.Drag,
    ReaderToolType.Select,
    ReaderToolType.PageMode,
    ReaderToolType.PageSearcher,
    ReaderToolType.ArrowLeft,
    ReaderToolType.ArrowRight,
    ReaderToolType.FourZoomIn,
    ReaderToolType.IntervalZoomIn,
    ReaderToolType.AllScreen,
    ReaderToolType.Menu,
  ],
  EditTools: [
    ReaderToolType.Painting,
    ReaderToolType.Highlighter,
    ReaderToolType.Shape,
    ReaderToolType.Line,
    ReaderToolType.DeleteAll,
    ReaderToolType.Delete,
    ReaderToolType.Text,
    ReaderToolType.Img,
    ReaderToolType.Mark
  ],
  TeachingTools: [
    ReaderToolType.NumberPicker,
    ReaderToolType.StickyNote,
    ReaderToolType.Whiteboard
  ],
  MathTools: [
    ReaderToolType.MathTools
  ],
  OfflineTools: []
}